import React, { useEffect, useState, useRef,useContext } from 'react';
import { ArrowRightOutlined, DownloadOutlined, PaperClipOutlined, LoadingOutlined, DownOutlined, InfoCircleOutlined, CheckCircleOutlined, ShareAltOutlined, CarOutlined, ShoppingCartOutlined, PrinterOutlined, InfoOutlined, FlagOutlined, ArrowLeftOutlined, EditOutlined, FilterOutlined } from '@ant-design/icons';
import { Dropdown, Row, Col, Button, message, Card, Modal, Tabs, Select, Checkbox, Radio, Form, Tooltip, Image, Input, Upload, Typography, Menu, InputNumber, Empty, Switch } from 'antd';
import TwoDImagesContext from '../../ContextFiles/TwoDImagesContext';
import "./TwoDImages.scss";

const ResolutionRadioButtons = ({ tabName }) => {
    const { 
        resolution, 
        setResolution, 
        onChangeResolution,
        onChangeTabResolution,
        getTabResolution
    } = useContext(TwoDImagesContext);

    // Use tab-specific resolution if tabName is provided, otherwise use global resolution
    const currentResolution = tabName ? getTabResolution(tabName) : resolution;
    
    const handleResolutionChange = (e) => {
        const newResolution = e.target.value;
        if (tabName) {
            onChangeTabResolution(tabName, newResolution);
        } else {
            onChangeResolution(e);
        }
    };

    return (
        <div className="resolutions-tab manrope f-14 black-55" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span className="resolutions-tab-span">
                Show:
            </span>
            <Radio.Group onChange={handleResolutionChange} value={currentResolution}>
                <Radio value='all'>
                    All
                </Radio>
                <Radio value='1k'>
                    1K
                </Radio>
                <Radio value='2k'>
                    2K
                </Radio>
                <Radio value='4k'>
                    4K
                </Radio>
                <Radio value='custom'>
                    Custom
                </Radio>
            </Radio.Group>
        </div>
    );
};

export default ResolutionRadioButtons;
